import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { useAppData } from "./hooks/useAppData";
import { AgendaPage } from "./pages/AgendaPage";
import { AppointmentFormPage } from "./pages/AppointmentFormPage";
import { PendingPage } from "./pages/PendingPage";
import "./App.css";

export default function App() {
  const { data, createAppointment, updateAppointment, deleteAppointment, setAppointmentStatus } = useAppData();

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<AgendaPage data={data} deleteAppointment={deleteAppointment} setAppointmentStatus={setAppointmentStatus} />} />
        <Route path="/pending" element={<PendingPage data={data} setAppointmentStatus={setAppointmentStatus} />} />
        <Route path="/appointments/new" element={<AppointmentFormPage data={data} createAppointment={createAppointment} updateAppointment={updateAppointment} />} />
        <Route path="/appointments/:appointmentId/edit" element={<AppointmentFormPage data={data} createAppointment={createAppointment} updateAppointment={updateAppointment} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}
